import { FC } from 'react';
import { Link } from 'react-router';

import AecomLogoBlack from '@/assets/images/aecom-logo-black.svg';
import { CustomerSupportButton } from '@/layouts/page-header/customer-support-button';
import { TranslationMenuButton } from '@/layouts/page-header/translation-menu-button';
import { UserMenuButton } from '@/layouts/page-header/user-menu-button';
import { Route } from '@/routes';

export const PageHeader: FC = () => {
  return (
    <nav
      className="flex flex-row w-full h-14 z-[60] bg-day-light-5 sticky top-0 left-0 justify-between items-center"
      role="navigation"
      aria-label="main navigation"
    >
      <span className="px-6">
        <Link
          to={`../${Route.PROJECTS}`}
          className="flex flex-row items-center justify-center w-[165px] min-w-[165px] h-full py-3.5 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-day-primary"
        >
          <img src={AecomLogoBlack} alt="AECOM Logo" className="block mb-0 h-12 w-auto" />
        </Link>
      </span>
      <div className="flex grow justify-end flex-row items-center px-4">
        <div className="flex flex-row items-center">
          <CustomerSupportButton />
          <UserMenuButton />
          <TranslationMenuButton />
        </div>
      </div>
    </nav>
  );
};
